import { ECurriculumUrls } from 'data/urls/curriculum.url';
import { authSplitApi } from '../helpers/slice.helpers';
import { TCourse } from 'data/types/Curriculum.types';

export const curriculumApi = authSplitApi('curriculum', [
  'courses',
]).injectEndpoints({
  endpoints: build => ({
    getExtendedCourses: build.query<TCourse[], void>({
      query: () => ({
        url: `${ECurriculumUrls.CURRICULUM}/${ECurriculumUrls.EXTENDED}`,
        method: 'GET',
      }),
      providesTags: ['courses'],
    }),

    getExtendedCourse: build.query<TCourse, { id: string }>({
      query: ({ id }) => ({
        url: `${ECurriculumUrls.CURRICULUM}/${id}/${ECurriculumUrls.EXTENDED}`,
        method: 'GET',
      }),
      providesTags: ['courses'],
    }),

    createCourse: build.mutation<void, { data: Partial<TCourse> }>({
      query: ({ data }) => ({
        url: `${ECurriculumUrls.CURRICULUM}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['courses'],
    }),

    updateCourse: build.mutation<void, { courseId: string; data: TCourse }>({
      query: ({ courseId, data }) => ({
        url: `${ECurriculumUrls.CURRICULUM}/${courseId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['courses'],
    }),

    deleteCourse: build.mutation<void, { courseId: string }>({
      query: ({ courseId }) => ({
        url: `${ECurriculumUrls.CURRICULUM}`,
        method: 'DELETE',
        body: { courseId },
      }),
      invalidatesTags: ['courses'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetExtendedCoursesQuery,
  useGetExtendedCourseQuery,
  useCreateCourseMutation,
  useUpdateCourseMutation,
  useDeleteCourseMutation,
} = curriculumApi;
